import { RouteFactory } from "@app/routePaths";
import { AwardsMenu } from "@events-awards/utils/types";
import { TabItem } from "@hooks/useTabs";

export const SBA_FOOTER_MENU = [
  {
    label: "About",
    link: RouteFactory.sbaAboutPage,
  },
  {
    label: "Awards",
    link: RouteFactory.sbaAwardsPage,
  },
  {
    label: "Winners",
    link: RouteFactory.eventsAwardsWinners("singapore-business-awards"),
  },
  {
    label: "News",
    link: RouteFactory.eventsAwardsNews("singapore-business-awards"),
  },
  {
    label: "Gallery",
    link: RouteFactory.eventsAwardsNews("singapore-business-awards"),
  },
  {
    label: "How to Nominate",
    link: RouteFactory.sbaNominatePage,
  },
  {
    label: "Contact Us",
    link: RouteFactory.sbaContactUsPage,
  },
];

export const SBA_NAVIGATION_ITEMS: AwardsMenu[] = [
  {
    text: "About",
    link: RouteFactory.sbaAboutPage,
    enabled: true,
  },
  {
    text: "Awards",
    link: RouteFactory.sbaAwardsPage,
    enabled: true,
  },
  {
    text: "Winners",
    link: RouteFactory.eventsAwardsWinners("singapore-business-awards"),
    enabled: true,
  },
  {
    text: "News",
    link: RouteFactory.eventsAwardsNews("singapore-business-awards"),
    enabled: true,
  },
  {
    text: "Gallery",
    link: RouteFactory.eventsAwardsGallery("singapore-business-awards"),
    enabled: true,
  },
  {
    text: "How to Nominate",
    link: RouteFactory.sbaNominatePage,
    enabled: true,
  },
];

export const AWARDS_TAB: TabItem[] = [
  {
    key: "businessman-of-the-year",
    label: "Businessman of the Year",
  },
  {
    key: "outstanding-chief-executive-of-the-year",
    label: "Outstanding Chief Executive of the Year",
  },
  {
    key: "the-enterprise-award",
    label: "The Enterprise Award",
  },
  {
    key: "outstanding-overseas-executive-of-the-year",
    label: "Outstanding Overseas Executive of the Year",
  },
  {
    key: "young-business-leader-of-the-year",
    label: "Young Business Leader of the Year",
  },
];

export const NOMINATIONS_TAB: TabItem[] = [
  {
    key: "nominations",
    label: "Nominations",
  },
  {
    key: "eligibility",
    label: "Eligibility",
  },
];
